import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router';
import { Button } from '@native-instruments/webex-ni';
import { useIntl } from '~/helpers/intl';
import env from '~/env';

// The color is hardcoded because it's a color just for this banner, not related to the design system.
// Some other hardcoded adjustment has to be made because of this.
export const BannerDealSOS = () => {
  const { t } = useIntl();
  const { language } = useParams<{ language: string }>();

  const [shouldDisplay, setShouldDisplay] = useState(false);

  useEffect(() => {
    const hasClosed =
      window.sessionStorage.getItem('niBannerClosed') === 'true';

    setShouldDisplay(!hasClosed);
  }, []);

  const onClose = () => {
    window.sessionStorage.setItem('niBannerClosed', 'true');
    setShouldDisplay(false);
  };

  if (!shouldDisplay) return null;

  return (
    <div
      id="ni-2-banner-sos"
      className="min-h-[56px] relative flex flex-col md:flex-row p-2 md:px-3 md:py-0 justify-center items-center w-full text-center bg-[#5AF99B]"
    >
      <span className="text-xs text-grey-90 font-bold">
        {t('TopBannerSosText', {
          fallback: 'Summer of Sound is on  – save up to 90%',
        })}
      </span>
      <Link
        className="text-xs mt-1 md:mt-0 ml-2 webex-btn webex-btn--primary font-bold px-1.5 py-[6px]"
        to={`${env.APP_BASE_URL}/${language}/catalog/summer-of-sound-2025/`}
      >
        {t('TopBannerSosCta', {
          fallback: 'Shop now',
        })}
      </Link>
      <Button
        onClick={onClose}
        variant="ghost"
        className="absolute top-50% right-2 text-2xl cursor-pointer font-bold"
      >
        ×
      </Button>
    </div>
  );
};
